import { Button } from "primereact/button";
import * as React from "react";
import { useTranslation } from "react-i18next";

const PrwcBasicButton = (props: any) => {
  const { onClick, labelKey, className, type = "button", icon, tooltipText, tooltipOptions={position: 'bottom'} } = props;
  const { t } = useTranslation();

  return (
    <span className="prw-basic-button">
      <Button
        onClick={onClick}
        type={type}
        label={t(labelKey)}
        icon={icon}
        className={className}
        tooltip={tooltipText}
        tooltipOptions={tooltipOptions}
      />
    </span>
  );
};

export default PrwcBasicButton;
